<template>
  <div class="documentation max-h-full h-full w-full absolute bg-white z-50 flex">
      <nav>
        <div class="sidebar h-full px-12 pt-12">
          <dynamic-link :text="documentationTopics" />
          <ul>
            <li>
              <h2><a href="https://github.com/beyondcode/tinkerwell-web-docs" target="_blank">
                  Contribute to the documentation
                </a></h2>
            </li>
          </ul>

        </div>
      </nav>
      <div class="method-docs pl-10">
        <div class="docs flex max-w-3xl leading-loose px-5">
          <dynamic-link :text="documentationHtml" />
        </div>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  import "highlight.js/styles/github.css";

  function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  Vue.component('dynamic-link', {
    template: `<component :is="transformed" /></component>`,

    props: ['text'],

    data () {
      return {}
    },
    
    computed: {
      transformed () {
        return { 
          template: `<div>${this.text}</div>`,
          methods: {
            runCode(encodedSnippet) {
              let decodedSnippet = atob(encodedSnippet);
              decodedSnippet = JSON.parse(decodedSnippet);

              this.$store.dispatch("tryCodeFromDocumentation", decodedSnippet);

              if (decodedSnippet.hash) {
                this.$store.dispatch("setSavedHash", decodedSnippet.hash);
                this.$router.push(`/snippets/${decodedSnippet.hash}`);
              }
            }
          },
        }
      }
    }
  });

  const marked = require('marked');
  const renderer = new marked.Renderer();
  let files = {};
    
  import documentationFile from '!!raw-loader!./../../snippets/documentation.md';


  if (process.env.NODE_ENV !== 'development') {
    files = require.context('!!raw-loader!./../../docs-rendered/', false, /\.html$/)
  } else {
    files = require.context('!!raw-loader!./../../snippets/', false, /\.md$/)    
  }
  const docs = {}

  files.keys().forEach(key => {
    if (key === './documentation.md') return
    if (process.env.NODE_ENV !== 'development') {
      docs[key.replace(/(\.\/|\.html)/g, '')] = files(key).default
    } else {
      docs[key.replace(/(\.\/|\.md)/g, '')] = files(key).default      
    }
  })

  renderer.link = (href, title, text) => {
    if (href.indexOf("#") === 0) {
      return `<a href="${href}">${text}</a>`;
    }  
    return `<router-link to="${href}">${text}</router-link>`;
  };

  renderer.heading = function (text, level) {
    const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');

    return `
            <p><a name="${escapedText}"></a></p>
            <h${level}>
              <a href="#${escapedText}">
                ${text}
              </a>
            </h${level}>`;
  };


  renderer.code = (code, infostring, escaped) => {
      if (infostring === 'try-code') {
        const codeObject = eval(`(${code})`);

        return `<a href="" 
        class="text-white inline-block px-4 py-2 bg-blue-300 rounded shadow"
        @click.prevent="runCode(\'${btoa(JSON.stringify(codeObject))}\')">Tinker with this code</a>`;
      }

      // let formattedCode = require('highlight.js').highlightAuto(code).value;
      let formattedCode = htmlEntities(code);

      return `
        <pre class="language-php" v-pre><code class="language-php">${formattedCode}</code></pre>
      `;
  };

  function renderMarkdown(markdown) {
    return marked(markdown, { renderer });
  }

  export default {
    data() {
      return {
      };
    },

    computed: {

      documentationTopics() {
        if (process.env.NODE_ENV !== 'development') {
          return docs['documentation'];
        } else {
          return renderMarkdown(documentationFile);
        }
      },

      documentationHtml() {
        if (process.env.NODE_ENV !== 'development') {
          if (this.$route.params.documentation) {
            return docs[this.$route.params.documentation];
          }
          return docs.responses;
        } else {
          if (this.$route.params.documentation) {
            return renderMarkdown(docs[this.$route.params.documentation]);
          }
          return renderMarkdown(docs.responses);
        }
      },

      documentation() {
        return this.$route.params.documentation
      }
    },

    methods: {
      closeDocumentation() {
        this.$router.push({ path: "/" });
        this.$store.dispatch("showDocumentation", false);
      }
    }
  }
</script>

<style>
.sidebar {
  background-color: #f8f8fc;
}

.docs {
  max-width: 42em;
}

.docs h1 {
    font-size: 2.5em;
    letter-spacing: 0;
}

.docs h1 a,
.docs h2 a,
.docs h3 a {
  color: #090910;
}

.docs h2 {
    font-size: 1.75em;
    letter-spacing: 0;
}

.docs h4 {
  font-size: 1em !important;
}

.docs h2 a:before, 
.docs h3 a:before {
  content: "#";
  font-weight: 400;
  margin-left: -25px;
  position: absolute;
  font-size: 28px;
  color: #4299e1;
  opacity: .6;
}
.docs h3 a:before {
  font-size: 17px;
}

.docs h3, 
.docs h4 {
    letter-spacing: 0;
    font-weight: 500;
}

.docs h1+ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.docs h1+ul li {
  display: block;
  margin-bottom: .5em;
}
.docs h1+ul li a {    
  position: relative;
  font-size: .89em;
  font-weight: 500;
  color: #090910;
  text-decoration: none;
}
.docs h1+ul ul {
  margin-top: .5em;
  padding: 0;
  margin-bottom: 0;
}
.docs h1+ul ul li {
  padding-left: 1.5em;
}

.docs h1+ul li a:before {
  content: "# ";
  color: #4299e1;
}

.docs code {
  font-size: .8rem;
  font-weight: 500;
  line-height: 1.9;
  color: #090910;
}

.docs p {
  font-size: 1rem;
  line-height: 1.8em;
  color: rgba(9,9,16,.7);
  margin-bottom: 2em;
}
.docs pre,
.docs pre code {
  background: #fbfbfd !important;
}

.docs pre {
  padding: 1em;
  margin: .5em 0 2em;
  overflow: auto;
  max-width: 100%;
}

:not(pre)>code[class*=language-], pre[class*=language-] {
  background: #fbfbfd;
  box-shadow: 0 1px 1px rgba(0,0,0,.075);
  color: #4299e1;
}

nav ul li {
  display: block;
  padding: .65em 0;
}

nav ul li a {
  display: block;
  font-size: .875em;
  font-weight: 500;
  color: #090910;
  text-decoration: none;
}

nav ul ul li a {
    position: relative;
    padding-left: 1em;
    font-weight: 400;
    line-height: 1.25;
}

nav ul ul li.active {
  font-weight: bold;
  color: #4299e1;
}

nav ul li h2 a,
nav ul li h2 {
  display: block;
  font-size: .875em;
  font-weight: 500;
  color: #090910;
  text-decoration: none;
  margin-bottom: 0;
  cursor: pointer;
  transition: all .3s ease;
}

#collection-method-list > p {
    column-count: 3; -moz-column-count: 3; -webkit-column-count: 3;
    column-gap: 2em; -moz-column-gap: 2em; -webkit-column-gap: 2em;
}

#collection-method-list a {
    display: block;
}
#collection-method code {
    font-size: 14px;
}

#collection-method:not(.first-collection-method) {
    margin-top: 50px;
}
.collection-method-list > p {
    column-count: 3; -moz-column-count: 3; -webkit-column-count: 3;
    column-gap: 2em; -moz-column-gap: 2em; -webkit-column-gap: 2em;
}

.collection-method-list a {
    display: block;
}

    #collection-method:not(.first-collection-method) {
        margin-top: 50px;
    }
</style>
